module.exports = __webpack_public_path__ + "img/icon_xx6.2153e90.png";